import React, { useState, useEffect } from 'react'
import { reduxForm } from 'redux-form'

import { signUpStepsData } from 'components/modals/v2/auth/sign_up_additional_details_modal/helpers/signup_steps_helper'
import { validateUserAvatar } from './helpers/validateUserAvatar'
import useSubmitLogo from './hooks/use_submit_logo'
import SignUpLogoContent from 'components/modals/v2/auth/sign_up_logo_modal/components/sign_up_logo_content'
import useLabel from 'components/modals/v2/auth/sign_up_logo_modal/hooks/use_label'

const accept = '.png, .jpg, .jpeg'
const SignUpLogo = ({ onClose, handleSubmit, ...props }) => {
  const [error, setError] = useState('')
  const isSubmitDisabled = props.invalid || props.submitting || props.pristine
  const onSubmit = useSubmitLogo({ onClose, setError })
  const label = useLabel()

  useEffect(() => {
    props.reset()
  }, [])

  return (
    <SignUpLogoContent
      allowLater={true}
      closable={false}
      error={error}
      accept={accept}
      label={label}
      isSubmitDisabled={isSubmitDisabled}
      onSubmit={handleSubmit(onSubmit)}
    />
  )
}

export default reduxForm({
  form: signUpStepsData.image.form,
  validate: validateUserAvatar,
  initialValues: { [signUpStepsData.imagePostpone.field]: false },
})(SignUpLogo)
